<div class="flex">
  <div class="flex-grow-1 flex">
    <div id="ecommerce-search-autocomplete" class="w-full"></div>
  </div>
  <div class="flex-none flex">
    <p-button icon="pi pi-search" class="search-button" (onClick)="doSearch()"> </p-button>
  </div>
</div>
